import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";

const Testimonial = ({ header, content, fullName, jobTitle = "", image }) => {
  return (
    <Box data-aos={"fade-up"}>
      <Typography
        sx={{
          textTransform: "uppercase",
          fontWeight: "medium",
        }}
        gutterBottom
        color={"secondary"}
        align={"center"}
      >
        {header}
      </Typography>
      <Typography
        component="p"
        variant={"h6"}
        fontWeight={400}
        align={"center"}
        gutterBottom
      >
        &ldquo;{content}&rdquo;
      </Typography>
      <Box
        component={"div"}
        display={"flex"}
        justifyContent={"center"}
        width={"100%"}
      >
        <ListItem component={Box} disableGutters sx={{width: "auto"}}>
          {image && (
            <ListItemAvatar>
              <Avatar sx={{ width: 50, height: 50, marginRight: 2 }}>
                {image}
              </Avatar>
            </ListItemAvatar>
          )}
          <ListItemText primary={fullName} secondary={jobTitle} />
        </ListItem>
      </Box>
    </Box>
  );
};

export default Testimonial;
